// src/render/fallback.ts

export function renderMissingMedia(
  section: HTMLElement,
  type: "video" | "image",
  filename?: string
): void {
  const fallback = document.createElement("div");
  fallback.className =
    "absolute inset-0 flex items-center justify-center bg-black text-white text-center px-4";
  fallback.classList.add("opacity-0", "transition");
  fallback.setAttribute("role", "alert");
  requestAnimationFrame(() => {
    fallback.classList.remove("opacity-0");
  });
  fallback.style.fontSize = "1.2rem";
  fallback.style.zIndex = "10";
  fallback.style.whiteSpace = "pre-line";
  fallback.style.borderRadius = "0.5rem";
  fallback.textContent = `${type.toUpperCase()} FILE MISSING${filename ? `:\n${filename}` : ""}`;
  section.appendChild(fallback);
}